import { FileImageOutlined } from "@ant-design/icons";
import { Form, Input, Modal, Switch, Select } from "antd";
import { SingleImageUpload } from "components/SingleImageUpload";
import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { api } from "services/api";
import Swal from "sweetalert2";
// import { IAddCourses } from "types";
import { getBase64Img } from "utils";

export const EditModuleModal: React.FC<any> = ({ ...props }) => {
	const [value, setValue] = useState<string>("");
	const [option, setOption] = useState<string>("");
	const [isActive, setIsActive] = useState<boolean>(false);
	const [imageWasEdited, setImageWasEdited] = useState<boolean>(false);
	const [moduleStatus, setModuleStatus] = useState<boolean>(false);

	const {
		form,
		isOpen,
		setCurrentImgURL,
		setIsOpen,
		currentImgURL,
		courseId,
		currentModuleInfo,
		onUpdated,
		titlePage,
	} = props;

	const handleRegister = (values: any) => {
		api
			.put(`/modules/${currentModuleInfo?.id}`, values)
			.then((result) => {
				if ([200, 201].includes(result.status)) {
					const {
						data: { feedback },
					} = result;
					onUpdated(result.data)
					Swal.fire({
						icon: "success",
						text: feedback["success"],
						confirmButtonColor: "#63b8cd",
					}).then(() => {
						setIsOpen(false);
						form.resetFields();
						setCurrentImgURL("");
						setModuleStatus(false);
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			})
			.catch((err) => {
				const status = err.response.status;
				const { feedback, errors } = err.response?.data;
				if (
					status === 400 ||
					status === 401 ||
					status === 404 ||
					status === 403 ||
					status === 500
				) {
					Swal.fire({
						icon: "error",
						text: feedback["error"]
							? feedback["error"]
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
				if (status === 422) {
					Swal.fire({
						icon: "error",
						text: errors?.message
							? errors?.message
							: "Desculpe, ocorreu algum problema =( Por favor tente novamente",
					});
					const html = document.getElementsByTagName("html");
					html.item(0)?.classList.remove("swal2-shown", "swal2-height-auto");
					document.body.classList.remove("swal2-shown", "swal2-height-auto");
				}
			});
	};
	const { Option } = Select;

	useEffect(() => {
		if (isOpen) {
			form.setFieldsValue({
				title: currentModuleInfo?.title,
				subtitle: currentModuleInfo?.subtitle
					? currentModuleInfo?.subtitle
					: "",
				description: currentModuleInfo?.description,
				visibility:
					currentModuleInfo?.visibility === "public" ? "public" : "pending",
			});
			setCurrentImgURL(
				currentModuleInfo?.image ? currentModuleInfo?.image : ""
			);
			setOption(
				currentModuleInfo?.visibility === "public" ? "public" : "pending"
			);
			setModuleStatus(currentModuleInfo?.status === "publish" ? true : false);
			setIsActive(currentModuleInfo?.is_active === true ? true : false);
			setValue(currentModuleInfo?.content ? currentModuleInfo?.content : "");
		}
		// eslint-disable-next-line
	}, [isOpen]);

	const handleChangeImage = (imageUrl: string) => {
		setImageWasEdited(true)
		setCurrentImgURL(imageUrl)
	} 

	return (
		<Modal
			title={<p style={{ margin: 0 }}>{titlePage} - Editar módulo</p>}
			open={isOpen}
			maskClosable={false}
			okText="Editar módulo"
			cancelText="Cancelar"
			onOk={() => {
				form
					.validateFields()
					.then((values: any) => {
						const allValues = imageWasEdited
							? {
									...values,
									status: moduleStatus ? "publish" : "pending",
									visibility: option,
									is_active: isActive,
									image: currentImgURL,
									order: "2",
									course_id: `${courseId}`,
							  }
							: {
									...values,
									status: moduleStatus ? "publish" : "pending",
									visibility: option,
									is_active: isActive,
									order: "2",
									course_id: `${courseId}`,
							  };
						handleRegister(allValues);
					})
					.catch((info: any) => {
						console.log("Validate Failed:", info);
					});
			}}
			onCancel={() => {
				setIsOpen(!isOpen);
				setCurrentImgURL("");
				setModuleStatus(false);
			}}
			width={700}
		>
			<Form form={form} name="new-course" autoComplete="off" layout="vertical">
				<div className="row row-cols-12 row-cols-md-2 justify-content-center align-items-center pe-0">
					<SingleImageUpload showImgURL={currentImgURL?? undefined} onChange={handleChangeImage}/>

					<div>
						<Form.Item
							label="Título"
							name="title"
							rules={[
								{
									required: true,
									message: "Título necessário",
								},
							]}
						>
							<Input placeholder="Título do módulo" />
						</Form.Item>
						<Form.Item
							label="Subtítulo"
							name="subtitle"
							rules={[
								{
									required: true,
									message: "Subtítulo necessário",
								},
							]}
						>
							<Input placeholder="Subtítulo do módulo" />
						</Form.Item>
						<Form.Item
							label="Descrição"
							name="description"
							rules={[
								{
									required: true,
									message: "Descrição necessária",
								},
							]}
						>
							<Input placeholder="Descrição do módulo" />
						</Form.Item>
					</div>
				</div>
				<div className="row">
					<div className="col-12 col-md-6">
						<Form.Item
							label="Visibilidade"
							name="visibility"
							rules={[
								{
									required: true,
									message: "Visibilidade necessária",
								},
							]}
						>
							<Select
								placeholder="Visibilidade"
								className="m-modules-modal__select"
								value={option}
								onChange={(e) => setOption(e)}
							>
								<Option value="public">Público</Option>
								<Option value="private">Privado</Option>
							</Select>
						</Form.Item>
					</div>
					<div className="col-12 col-md-6 row row-cols-2 pb-3 align-items-center text-center">
						<div>
							<p>Publicado</p>
							<Switch
								checked={moduleStatus}
								onClick={(e) => setModuleStatus(e)}
							/>
						</div>
						<div>
							<p>Ativo</p>
							<Switch checked={isActive} onClick={(e) => setIsActive(e)} />
						</div>
					</div>
					<div
						className="m-modules-modal__textarea"
						style={{ marginTop: "20px" }}
					>
						<ReactQuill theme="snow" value={value} onChange={setValue} />
					</div>
				</div>
			</Form>
		</Modal>
	);
};
